import { z } from "zod";
import { Fuel, Transmission, VehicleType } from "@/gql/graphql";

export const createVehicleSchema = z
  .object({
    supplier: z.object({
      connect: z.string(),
    }),
    name: z.string().min(1),
    type: z.string().min(1),
    hire_unit_rate: z.number(),
    extra_hire_unit_rate: z.number(),
    seatbelts: z.number().min(1).optional(),
    transmission: z.nativeEnum(Transmission).optional(),
    fuel: z.nativeEnum(Fuel).optional(),
  })
  .refine(
    (data) => {
      if (data.type === VehicleType.Caravan) {
        return true;
      }
      return (
        data.seatbelts !== undefined &&
        data.transmission !== undefined &&
        data.fuel !== undefined
      );
    },
    {
      message: "Seatbelts, transmission, and fuel are required",
      path: ["seatbelts"],
    },
  );
